import React, { useState, useEffect } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import dayjs from "dayjs";
import { Line } from 'react-chartjs-2';
import { useTemas } from '../hooks/useTemas.jsx'
import { useColors } from '../hooks/useColors'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

var yLabels = {
    25: 'D',
    50: 'C',
    75: 'B',
    100: 'A',
}

export const LineChart = ({ cuestionarios }) => {

    const { getCalificationColor } = useColors()
    const [dataSets, setdataSets] = useState([])
    const { temas } = useTemas()

    const options = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: false,
            },
        },
        scale: {
            min: 0,
            max: 100,
        },
        scales: {
            y: {
                ticks: {
                    stepSize: 25,
                    callback: function (value, index, values) {
                        return yLabels[value];
                    },
                    color: [getCalificationColor('D'), getCalificationColor('C'), getCalificationColor('B'), getCalificationColor('A')],
                    font: {
                        size: 25,
                    }
                },
            },
        }
    };

    // const config = {
    //     type: 'line',
    //     options: {
    //       responsive: true,
    //       plugins: {
    //         legend: {
    //           position: 'top',
    //         },
    //         title: {
    //           display: true,
    //           text: 'Chart.js Line Chart'
    //         }
    //       }
    //     },
    //   };

    function strToArray(str, limit) {
        const words = str.split(' ')
        let aux = []
        let concat = []

        for (let i = 0; i < words.length; i++) {
            concat.push(words[i])
            let join = concat.join(' ')
            if (join.length > limit) {
                aux.push(join)
                concat = []
            }
        }

        if (concat.length) {
            aux.push(concat.join(' ').trim())
        }

        return aux
    }
    
    useEffect(() => {
        var ds = []
        cuestionarios.map(c => (
            ds = [...ds, {
                label: dayjs(c.fecha_fin).format("DD/MM/YYYY"),
                data: c.puntuacionTemas.map((puntuacionTema) => puntuacionTema.puntuacion),
                borderColor: getCalificationColor(c.calificacion),
                backgroundColor: getCalificationColor(c.calificacion)
            }]
        ))
        setdataSets(ds)

    }, [cuestionarios])

    const data = {
        labels: temas ? (temas.map(t => strToArray(t.texto, 10))) : (null),
        datasets: dataSets,
    };

    return (
        <Line options={options} data={data} />
    )
}

